import Phaser from 'phaser';
import { gameConfig } from './config/game-config';
import speechManager from './utils/speech-manager';

const game = new Phaser.Game(gameConfig);

if (import.meta.env?.DEV) {
  (window as any).game = game;
}

// Initialize speech recognition when the game is ready
game.events.once('ready', () => {
  speechManager.init(game);
});

export default game;
